module.exports = __webpack_public_path__ + "img/8.4b4e8b95.png";